<template>
    <div>
        <div class="bg-overlay"></div>
        <div class="help-me">
            <h3>{{trans('talents.helpme.title')}}</h3>

            <p v-html="trans('talents.helpme.text')"></p>
            <p>Team Dutch Casting Agency</p>
            <a href="mailto:info@dutchcasting.nl" class="btn-help-yes">{{trans('talents.helpme.btn-yes')}}</a>
            <a href="#" class="btn-help-no" @click.prevent="hideOverlay">{{trans('talents.helpme.btn-no')}}</a>
        </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'

    export default {
        props: {
        },
        data: function () {
            return {
                //dontShowConfirm: false,
            }
        },
        computed: {
            ...mapState(['deleteFavoriteId']),
        },
        methods: {
            hideOverlay() {
                this.$parent.$emit('hideHelpMe')
            },
        },
    };
</script>